import { render, staticRenderFns } from "./BorcCekleri.vue?vue&type=template&id=9c0a92e4&scoped=true"
import script from "./BorcCekleri.vue?vue&type=script&lang=js"
export * from "./BorcCekleri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0a92e4",
  null
  
)

export default component.exports